import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ValidateInitiatorRole } from '../../helper/validateRole';
import { Auth } from 'aws-amplify';
import Login from '../../setup/auth/login.component';


const Initiator = () => {

    const [isAuthenticated, userHasAuthenticated] = useState(true);


    async function onLoad() {
        try {
            await Auth.currentSession();
            if (!ValidateInitiatorRole()) { userHasAuthenticated(false); }
        } catch (e) {
            userHasAuthenticated(false);
        }
    }

    useEffect(() => {
        onLoad();
    }, []);

    return isAuthenticated ? (
        <>
            <div className='text-center py-8'>GUSD Apps :-Initiator Main Page</div>

            <div className='grid grid-cols-4 gap-4 px-4'>
                <Link to='/initiator/weekly_absence_report' className='text-[14px] text-[#101828] bg-white mb-8 xl:mb-[2.083vw] flex items-center justify-center font-medium  googlebtn p-8'>
                    Weekly Absence Report-Classified
                </Link>
                {/* <Link to='/initiator/sixth_period_report' className='text-[14px] text-[#101828] bg-white mb-8 xl:mb-[2.083vw] flex items-center justify-center font-medium  googlebtn p-3'>
                    6th Period Report
                </Link> */}
                <Link to='/sixth_period_report_list' className='text-[14px] text-[#101828] bg-white mb-8 xl:mb-[2.083vw] flex items-center justify-center font-medium  googlebtn p-3'>
                    6th Period Report
                </Link>
                <Link to='/initiator/serviceagreement' className='text-[14px] text-[#101828] bg-white mb-8 xl:mb-[2.083vw] flex items-center justify-center font-medium  googlebtn p-3'>
                    Personal Service Management
                </Link>
                <Link to='/time_report' className='text-[14px] text-[#101828] bg-white mb-8 xl:mb-[2.083vw] flex items-center justify-center font-medium  googlebtn p-3'>
                    Time Report
                </Link>

            </div>
        </>
    ) : (
        <Login sessionExpired={1} />
    );
}

export default Initiator